import EventEmitter from './EventEmitter';

export default class Time extends EventEmitter {
    start: number;
    current: number;
    elapsed: number;
    delta: number;
    private rafId: number = 0;
    private running = true;
    private visible = document.visibilityState !== 'hidden';

    constructor() {
        super();
        this.start = Date.now();
        this.current = this.start;
        this.elapsed = 0;
        this.delta = 16;
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.rafId = window.requestAnimationFrame(this.tick);
    }

    private tick = () => {
        const now = Date.now();
        this.delta = now - this.current;
        this.current = now;
        this.elapsed = this.current - this.start;
        if (this.running && this.visible) this.trigger('tick');
        this.rafId = window.requestAnimationFrame(this.tick);
    };

    private onVisibilityChange = () => {
        this.visible = document.visibilityState !== 'hidden';
        this.current = Date.now();
    };

    destroy() {
        this.running = false;
        window.cancelAnimationFrame(this.rafId);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
}
